export function getBlockWidth(block: HTMLElement | null): number {
  if (!block) {
    return 0;
  }

  return block.clientWidth;
}
